<template>
  <div class="page-annuaire page-annuaire-substances">
    <main class="main">
      <breadcrumbs></breadcrumbs>

      <div class="page_title">
        <h1>Substances actives & Macro-organismes</h1>
      </div>

      <div class="main-content">
        <div
          class="col-100 filtre filtre-subtancgit es"
          v-on:keydown.enter="filter"
        >
          <h2 class="font-bold">Rechercher les substances actives</h2>
          <div class="labels">
            <SuggesterInput
              v-on:update:suggesterState="suggesterState = $event"
              ressource="activesubstances"
              fieldname="name"
              verbose="Nom de la substance"
              v-model="searchInput.name"
            ></SuggesterInput>

            <div class="label">
              <label for="numeroCAS">Numéro CAS</label>
              <input
                type="search"
                id="numeroCAS"
                v-on:update:suggesterState="suggesterState = $event"
                v-model="searchInput.cas_number"
              />
            </div>

            <div class="label">
              <label for="identite-type">Type</label>
              <select v-model="searchInput.types" id="identite-type">
                <option value=""></option>
                <option v-for="type in this.types" :key="type">
                  {{ type }}
                </option>
              </select>
            </div>

            <div class="label">
              <label for="activity_select">Activité</label>
              <select v-model="searchInput.principal_activity" id="activity_select">
                <option value=""></option>
                <option v-for="principal_activity in this.activities" :key="principal_activity">
                  {{ principal_activity }}
                </option>
              </select>
            </div>

            <div class="label">
              <label for="identite-famille"> Famille chimique </label>
              <select
                name="identite-famille"
                id="identite-famille"
                v-model="searchInput.family"
              >
                <option value=""></option>
                <option v-for="family in families" :key="family">
                  {{ family }}
                </option>
              </select>
            </div>

            <SuggesterInput
              v-on:update:suggesterState="suggesterState = $event"
              ressource="cultivations"
              fieldname="name"
              verbose="Culture"
              v-model="searchInput.cultivations"
              select-required
            ></SuggesterInput>

            <SuggesterInput
              v-on:update:suggesterState="suggesterState = $event"
              ressource="targets"
              fieldname="name"
              verbose="Cible"
              v-model="searchInput.targets"
            ></SuggesterInput>
          </div>

          <div class="pt-2">
            <div class="flex justify-end">
              <button class="grey-background" @click="clearSearch">
                Effacer la recherche
              </button>
              <button class="orange-background" @click="filter">
                Lancer la recherche
              </button>
            </div>
            <div class="flex justify-end pt-3">
              <router-link
                :to="{ name: 'substancesAdvancedSearch' }"
                class="orange-link"
              >
                Accéder à la recherche avancée
              </router-link>
            </div>
          </div>
        </div>

        <substances-listing
          :activeSubstances="activeSubstances"
          :mobile="mobile"
          :page.sync="queryParams.page"
          @changePage="updateUrl()"
        ></substances-listing>
      </div>
    </main>
  </div>
</template>

<script>
import Substances from '@/api/substances.js'
import SearchMixin from '@/mixins/SearchMixin.js'
import Breadcrumbs from '@/components/Breadcrumbs'
import SuggesterInput from '@/components/SuggesterInput'
import SubstancesListing from '@/components/SubstancesListing'

export default {
  name: 'Substances',
  components: { SuggesterInput, Breadcrumbs, SubstancesListing },
  mixins: [SearchMixin],

  props: {
    mobile: Boolean
  },

  data () {
    return {
      errors: {
        page: null
      },
      activeSubstances: {},
      queryParams: {
        page: 1
      },
      searchInput: {
        name: '',
        cas_number: '',
        types: '',
        principal_activity: '',
        family: '',
        cultivations: '',
        targets: ''
      },
      suggesterState: false,
      types: [],
      families: [],
      activities: [], 
    }
  },

  created () {
    this.queryParams = { ...this.$route.query }
    this.putQueryParamsInSearchInput()
    this.getSubstances()
    this.getTypes()
    this.getFamilies()
    this.getActivities()
  },

  beforeRouteUpdate (to, from, next) {
    this.errors.page = null
    this.queryParams = { ...to.query }
    this.putQueryParamsInSearchInput()
    Promise.resolve(this.getSubstances()).finally(() => next())
  },

  methods: {
    getSubstances () {
      this.queryParams.page = Number(this.queryParams.page) || 1

      return Substances.list(this.queryParams).then((response) => {
        this.activeSubstances = response.substances
        if (!this.activeSubstances.results.length) {
          this.errors.page =
            'Aucun résultat pour la page et les paramètres de recherche demandés'
        }
      })
    },

    getTypes () {
      return Substances.types().then((response) => {
        this.types = response
      })
    },

    getFamilies () {
      return Substances.families().then((response) => {
        this.families = response
      })
    },

    getActivities () {
      return Substances.activities().then((response) => {
        this.activities = response
      })
    },

    filter (event) {
      if (!this.suggesterState || event.type === 'click') {
        this.queryParams.page = 1
        this.putSearchInputInQueryParams()
        this.updateUrl()
      }
    },

    clearSearch () {
      for (const prop in this.searchInput) {
        this.searchInput[prop] = ''
      }
      this.putSearchInputInQueryParams()
      this.queryParams.page = 1
      this.updateUrl()
    }
  }
}
</script>
